import { Expose, Type } from "class-transformer";
import ShopRes from "../shop/ShopRes";
import NotificationType from "../../enum/NotificationType";

export default class NotificationRes {
  @Expose() readonly notificationId!: number;
  @Expose() readonly companyId!: number;
  @Expose() readonly title!: string;
  @Expose() readonly content!: string;
  @Expose() readonly type!: NotificationType;
  @Expose() readonly sort!: number | null;
  @Type(() => Date)
  @Expose()
  readonly startDate!: Date | null;
  @Type(() => Date)
  @Expose()
  readonly endDate!: Date | null;
  @Expose()
  readonly isIndefinite!: boolean | null;
  @Type(() => ShopRes)
  @Expose()
  readonly shops!: ShopRes[];
}
